export const type = {
  anualList: '[SC Iniciado Autorizado Anual] anualList',
  mensualList: '[SC Iniciado Autorizado Mensual] mensualList',
};
